import * as React from 'react'
import { MenuOpen, FavoriteTrainingClose, CertificateIconClose } from '@/icons'
import CustomPalette from '@/theme/CustomPalette'

export const userIsAuthorize = (authorize: string | unknown[], roles: string[]) =>
  roles.some((role) => authorize?.includes(role))

export const getCurrentIcon = (iconName?: string) => {
  const iconProps = { color: CustomPalette.NightBlue200, fontSize: 22 } as const

  if (!iconName) return <MenuOpen sx={iconProps} />

  switch (iconName) {
    case 'FavoriteTraining':
      return <FavoriteTrainingClose sx={iconProps} />
    case 'CertificateIcon':
      return <CertificateIconClose sx={iconProps} />
    default:
      return <MenuOpen sx={iconProps} />
  }
}
